/* eslint-disable  */
import AmortizationSchedule, {
    ChildAmortizationScheduleRef,
} from 'app/views/components/amortization-scheduler/amortization-schedule'
import VerticalStepper from 'app/views/components/stepper-component'
import UpdatedFacilitiesModal, {
    ChildFacilityRef,
} from 'app/views/pages/deals-management/facilities/updated-facilities-form'
import { useEffect, useRef, useState } from 'react'
import ManageFees, { ChildManageFeesRef } from 'app/views/components/Fees/fees'
import ManageLenders, {
    ChildManageLendersRef,
} from 'app/views/components/lenders/manage-lenders'
import ManageIro, {
    ChildManageIroRef,
} from 'app/views/components/interest-rate-options/manage-iro'
import StepperFooter from 'app/views/components/modals/stepper-footer'
import StepHeader from 'app/views/components/modals/step-header'
import Sublimits, {
    ChildSublimitsRef,
} from 'app/views/components/sublimits/sublimits'
import { useDispatch, useSelector } from 'react-redux'
import { Alert } from '@mantine/core'
import { FacilityParams } from 'app/models/facility-params'
import { resetFacilityLendersPositions } from 'app/state/ducks/lenders-positions/actions'
import { resetFacilityFees } from 'app/state/ducks/fees/actions'
import { resetFacilitySchedulerAmortization } from 'app/state/ducks/amortization/actions'
import ManagePikScheduler, { ChildPikSchedulerRef } from 'app/views/components/pik-scheduler/manage-pik-scheduler'
import ManageFacilityPricingGrid from 'app/views/components/facility-pricing-grid/manage-facility-pricing-grid'
import { loadOneFacilityAmounts } from 'app/state/ducks/facilities/thunks'
import {
    getFacilityAmountsForOneFacility,
    getFacilityAmountsForOneFacilityStatus,
} from 'app/state/ducks/facilities/selectors'
import { FacilityAmountsForOneFacilityStatus } from 'app/state/ducks/facilities/reducer'

type Props = {
    deal: any
    facility: any
    amendment?: string | null
    onClose: () => void
    step?: number
}

interface CustomStepContentProps {
    onNext: () => void
    onPrevious: () => void
}

export const showAmortizationSchedule = (facility: FacilityParams) => {
    if (
        facility?.facilityType === 'TL' ||
        facility?.facilityType === 'TLA' ||
        facility?.facilityType === 'TLB' ||
        facility?.facilityType === 'TLC' ||
        facility?.facilityType === 'DDTL'
    ) {
        return true
    } else {
        return false
    }
}

export const UpdatedFacilitiesScreen: React.FC<Props> = ({
    deal,
    facility,
    onClose,
    step,
    amendment,
}) => {
    const [updated_facility, setFacility] = useState(facility)

    const dispatch = useDispatch()
    const facilityAmounts = useSelector(getFacilityAmountsForOneFacility)
    const facilityAmountsStatus: FacilityAmountsForOneFacilityStatus = useSelector(getFacilityAmountsForOneFacilityStatus)

    useEffect(() => {
        if (facility?.id) {
            dispatch(loadOneFacilityAmounts(facility.id))
        }
    }, [facility?.id])

    useEffect(() => {
        if (!facility) {
            dispatch(resetFacilityLendersPositions())
            dispatch(resetFacilityFees())
            dispatch(resetFacilitySchedulerAmortization())

        }
    }, [facility])

    const showPikScheduler = (f: any) => {
        return f?.pikOption === 'PIK_Scheduled'
    }

    const stepsToDisable = (facility: FacilityParams) => {
        const initialDisabledSteps =
            facility?.isSublimit === false ||
                facility?.facilityType === 'TL' ||
                facility?.facilityType === 'TLA' ||
                facility?.facilityType === 'TLB' ||
                facility?.facilityType === 'TLC'
                ? [2]
                : []
        const amotizationEnabled = showAmortizationSchedule(facility) ? [] : [6]
        const pikOption = facility?.pikOption === 'PIK_Scheduled' ? [] : [7]
        const facilityPricingGrid = deal?.isPricingGrid ? [] : [5]
        const stepsToDisable = initialDisabledSteps.concat(amotizationEnabled, pikOption, facilityPricingGrid)
        return stepsToDisable
    }

    const [disabledSteps, setDisabledSteps] = useState<any>(
        stepsToDisable(updated_facility)
    )

    const FacilityContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildFacilityRef>(null)
        const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true)
        const [loading, setLoading] = useState(false);

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndNext = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onNext()
            }
        }


        const hasAmountsError = Boolean(facility?.id) && facilityAmountsStatus === 'error'

        return (
            <div className="create-new">
                {hasAmountsError && (
                    <Alert color="red" title="Facility amount history unavailable" mb="md">
                        We couldn't load the facility amount history. Saving is disabled because the displayed amount may not reflect the value as of the amendment's effective date. Close and try again.
                    </Alert>
                )}
                <UpdatedFacilitiesModal
                    deal={deal}
                    facility={updated_facility}
                    amendment={amendment}
                    ref={childRef}
                    setSaveButtonDisabled={setIsSaveButtonDisabled}
                    setDisabledSteps={setDisabledSteps}
                    setFacility={setFacility}
                    dealStepper={false}
                    onClose={onClose}
                    facilityAmounts={facilityAmounts}
                    facilityAmountsStatus={facilityAmountsStatus}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={handleSaveFacilityAndNext}
                    onClose={onClose}
                    loading={loading}
                    showPrevious={false}
                    disableSave={hasAmountsError}
                />
            </div>
        )
    }

    const LenderAllocationContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildManageLendersRef>(null)
        const [loading, setLoading] = useState(false);

        const handleNext = () => {
            if (typeof onNext === 'function') {
                onNext()
                if (updated_facility?.isSublimit === false) {
                    onNext()
                }
            }
        }

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndProceed = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                handleNext()
            }
        }

        const handlePrevious = () => {
            if (typeof onNext === 'function') {
                onPrevious()
            }
        }

        return (
            <div className="create-new">
                <ManageLenders
                    facility={updated_facility}
                    setFacility={setFacility}
                    ref={childRef}
                    amendment={amendment}
                    onClose={onClose}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={handleSaveFacilityAndProceed}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const SublimitsContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildSublimitsRef>(null)
        const [loading, setLoading] = useState(false);

        const handleNext = () => {
            if (typeof onNext === 'function') {
                onNext()
            }
        }

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndProceed = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                handleNext()
            }
        }

        const handlePrevious = () => {
            if (typeof onNext === 'function') {
                onPrevious()
            }
        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <Sublimits
                    facility={updated_facility}
                    amendment={amendment}
                    setFacility={setFacility}
                    ref={childRef}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={handleSaveFacilityAndProceed}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const IroContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildManageIroRef>(null)
        const [loading, setLoading] = useState(false);

        const handleNext = () => {
            if (typeof onNext === 'function') {
                onNext()
            }
        }

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndProceed = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                handleNext()
            }
        }

        const handlePrevious = () => {
            if (typeof onNext === 'function') {
                onPrevious()
                if (updated_facility?.isSublimit === false) {
                    onPrevious()
                }
            }
        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <ManageIro
                    facility={updated_facility}
                    amendment={amendment}
                    setFacility={setFacility}
                    ref={childRef}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={handleSaveFacilityAndProceed}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const FeesContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildManageFeesRef>(null)
        const [loading, setLoading] = useState(false);

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndNext = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onNext()
                if (!deal?.isPricingGrid) {
                    onNext()
                    if (!showAmortizationSchedule(updated_facility)) {
                        onNext()
                    }
                }
            }
        }

        const handlePrevious = () => {
            if (typeof onNext === 'function') {
                onPrevious()
            }

        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <ManageFees
                    facility={updated_facility}
                    amendment={amendment}
                    setFacility={setFacility}
                    ref={childRef}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={showAmortizationSchedule(updated_facility) || showPikScheduler(updated_facility) || deal?.isPricingGrid ? handleSaveFacilityAndNext : undefined}
                    showSaveAndProceed={showAmortizationSchedule(updated_facility) || showPikScheduler(updated_facility) || deal?.isPricingGrid}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const FacilityPricingGrid: React.FC<CustomStepContentProps> = ({
        onPrevious,
        onNext,
    }) => {
        const childRef = useRef<ChildPikSchedulerRef>(null)
        const [loading, setLoading] = useState(false);

        const handleNext = () => {
            if (typeof onNext === 'function') {
                onNext()
                if (!showAmortizationSchedule(updated_facility)) {
                    onNext()
                }
            }
        }


        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handleSaveFacilityAndProceed = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                handleNext()
            }
        }


        const handlePrevious = () => {
            if (typeof onPrevious === 'function') {
                onPrevious()
            }
        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <ManageFacilityPricingGrid
                    facility={updated_facility}
                    setFacility={setFacility}
                    ref={childRef}
                    amendment={amendment}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={handleSaveFacilityAndProceed}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const AmortizationScheduleContent: React.FC<CustomStepContentProps> = ({
        onNext,
        onPrevious,
    }) => {
        const childRef = useRef<ChildAmortizationScheduleRef>(null)
        const [loading, setLoading] = useState(false);

        const handleNext = () => {
            if (typeof onNext === 'function') {
                onNext()
            }
        }

        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }
        const handleSaveFacilityAndProceed = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                handleNext()
            }
        }

        const handlePrevious = () => {
            if (typeof onNext === 'function') {
                onPrevious()
                if (!deal?.isPricingGrid) {
                    onPrevious()
                }
            }
        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <AmortizationSchedule
                    deal={deal}
                    amendment={amendment}
                    facility={updated_facility}
                    setFacility={setFacility}
                    ref={childRef}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    onSaveAndProceed={showPikScheduler(updated_facility) ? handleSaveFacilityAndProceed : undefined}
                    showSaveAndProceed={showPikScheduler(updated_facility)}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const PikContent: React.FC<CustomStepContentProps> = ({
        onPrevious,
    }) => {
        const childRef = useRef<ChildPikSchedulerRef>(null)
        const [loading, setLoading] = useState(false);


        const handleSaveFacilityAndExit = async () => {
            if (childRef.current) {
                setLoading(true)
                await childRef.current.handleClick()
                setLoading(false)
                onClose()
            }
        }

        const handlePrevious = () => {
            if (typeof onPrevious === 'function') {
                onPrevious()
                if (!showAmortizationSchedule(updated_facility)) {
                    onPrevious()
                    if (!deal?.isPricingGrid) {
                        onPrevious()
                    }
                }
            }
        }

        return (
            <div className="create-new">
                <StepHeader onClose={onClose} />
                <ManagePikScheduler
                    facility={updated_facility}
                    setFacility={setFacility}
                    ref={childRef}
                    amendment={amendment}
                />
                <StepperFooter
                    onSaveAndExit={handleSaveFacilityAndExit}
                    showSaveAndProceed={false}
                    onPrevious={handlePrevious}
                    onClose={onClose}
                    loading={loading}
                />
            </div>
        )
    }

    const steps = [
        {
            label: '1. Facility',
            content: (
                <FacilityContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'i. Lender Allocation',
            content: (
                <LenderAllocationContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'ii. Sublimits',
            content: (
                <SublimitsContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'iii. Interest Rate Options',
            content: (
                <IroContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'iv. Fees',
            content: (
                <FeesContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'v. Pricing Grid',
            content: (
                <FacilityPricingGrid
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'vi. Amortization Schedule',
            content: (
                <AmortizationScheduleContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
        {
            label: 'vii. PIK Scheduler',
            content: (
                <PikContent
                    onNext={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                    onPrevious={function (): void {
                        throw new Error('Function not implemented.')
                    }}
                />
            ),
        },
    ]

    return (
        <>
            {!updated_facility || Object.keys(updated_facility).length === 0 ? (
                //create
                <VerticalStepper
                    steps={steps}
                    disabledSteps={[1, 2, 3, 4, 5, 6, 7]}
                    step={step}
                />
            ) : (
                // edit
                <VerticalStepper
                    steps={steps}
                    disabledSteps={disabledSteps}
                    step={step}
                />
            )}
        </>
    )
}
